import api from '../../plugins/api';

// ÐÑÐ³ÑÑÐ·ÐºÐ¸ ÑÑÐ¾ÑÐ¾Ð² (CSV Ð¸Ð· App Store Connect Ð¸ Google Play), FormData Ñ Ð¿Ð¾Ð»ÐµÐ¼ files
const importAppInstalls = (formData) => {
  return api.uploadFile('/api/crm/reports/app-installs/import', formData);
};

export default importAppInstalls;
